import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Text from '../../Text';

import * as styles from './SecondaryNavDesktop.module.less';

const SecondaryNavDesktopWrapper = ({ children, text, isMinimized }) => {
  const exploreText = `Explore${text ? ` ${text}` : ''}:`;
  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.minimized]: isMinimized,
      })}
    >
      <div className={styles.wrapperContainer}>
        <Text className={styles.wrapperHeader}>{exploreText}</Text>
        <ul className={styles.wrapperList}>{children}</ul>
      </div>
    </div>
  );
};

SecondaryNavDesktopWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
  isMinimized: PropTypes.bool,
};

SecondaryNavDesktopWrapper.defaultProps = {
  text: '',
  isMinimized: false,
};

export default SecondaryNavDesktopWrapper;
